require('@telefonica/coco.lib-staticAt');
require('@telefonica/coco.lib-staticAei');

require('./css/loginApp.css');



var T3_COMUN_APP = global.T3_COMUN_APP;

var CNT = {
	name: 'loginApp',
	ngModule: {}
};


CNT.ngModule = angular.module(CNT.name, [T3_COMUN_APP.NAME, 'ui.router', 'gettext', 'oc.lazyLoad', 'ui.bootstrap', 'ui.date', 'ngResource']);
CNT.init =  function () {
    angular.bootstrap(document, [CNT.name]);
};

global.CNT = CNT;

var context = require.context('./', false, /^.*_(constant|controller|directive|service|model).js$/);
context.keys().forEach(context); 

require('./app');

CNT.init();